<template>
  <el-dialog
    class="dialog-container"
    :visible.sync="dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    :title="row ? '编辑明细' : '添加明细'"
    center>
    <div class="flex flex-direction padding">
      <el-form class="ruleForm" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
        <el-form-item prop="type" label="费用类别">
          <el-input v-model="ruleForm.type" placeholder="请输入">
          </el-input>
          <div class="tishi" style="color: #999999">费用类别如：人力成本费、物资费、场地租赁费、交通费、专家费、临时聘用人员劳务费、志愿者补贴、管理费、税费等</div>
        </el-form-item>

        <el-form-item prop="price" label="单价" required>
          <el-input v-model="ruleForm.price" autocomplete="off" placeholder="请输入" @input="sum">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="标准">
          <el-input v-model="ruleForm.unit" autocomplete="off" placeholder="如“/人/天”“/场地/小时”“/场地/次”"></el-input>
        </el-form-item>
        <el-form-item prop="number" label="数量">
          <el-input v-model.number="ruleForm.number" autocomplete="off" @input="sum" placeholder="请输入">
          </el-input>
        </el-form-item>
        <el-form-item prop="total_price" label="资金金额">
          <el-input v-model="ruleForm.total_price" placeholder="" readonly>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-operate flex align-center justify-center">
        <el-button class="btn min round" type="info" @click="cancel">取消</el-button>
        <el-button class="btn min round" type="primary" @click="submitForm('ruleForm')">
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {mutiply} from '@/tools'

export default {
  name: "ApplyServiceDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    idx: {
      type: [String,Number],
      default: ''
    },
    row: {
      type: [String,Object],
      default: ''
    },
  },
  data() {
    var validate = (rule, value, callback) => {
      if (!/^[0-9]\d*(\.\d+)?$/.test(value)) {
        callback(new Error('输入有误'));
      } else {
        callback();
      }
    };
    return {
      options:[],
      ruleForm: {
        type: '',
        price: 0,
        unit:'',
        number: 1,
        total_price: '',
        remark:''
      },
      rules: {
        type: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        unit: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        price: [
          {validator: validate, trigger: 'blur'}
        ],
        number: [
          {required: true, message: '请输入'},
          { type: 'number', message: '数量必须为数字值'}
        ]

      },
    }
  },
  created() {
  },
  methods: {

    sum() {
      if(this.ruleForm.price == '' ||  this.ruleForm.number == '') return
      if(!/^[0-9]\d*(\.\d+)?$/.test(this.ruleForm.price)) return;
      this.ruleForm.total_price = mutiply(this.ruleForm.price, this.ruleForm.number)
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('watchState', {
            idx: this.idx,
            type: this.row.type ? 'edit' : 'add',
            obj:{
              type: this.ruleForm.type,
              price: Number(this.ruleForm.price).toFixed(2),
              unit: this.ruleForm.unit,
              number: this.ruleForm.number,
              total_price: Number(this.ruleForm.total_price).toFixed(2),
              remark: this.ruleForm.remark
            }
          })
          this.clearContent()
        }
      });
    },
    clearContent() {
      this.$refs.ruleForm.resetFields()
    },
    cancel() {
      this.$emit('watchState', false)
      // this.clearContent()
    }
  },
  watch: {
    dialog(){
      if(this.dialog){
        console.log(this.row)
        this.ruleForm = this.row.type ? this.row : {
          type: '',
          price: 0,
          unit: '',
          number: 1,
          total_price: '',
          remark:''
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
